// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_is-0";
export var fileCarousel = "_is-2";
export var removeFileButton = "_is-1";